import { useCallback } from 'react';

import type { WidgetProps } from '@rjsf/utils';

import { KeyValue } from '@/components/ui/keyValue/keyValue';
import { ProseList } from '@/components/ui/prose/prose.list';

type Props = WidgetProps;

export const CheckboxesWidget = (props: Props) => {
  const { enumOptions } = props.options;

  const getCheckedItems = useCallback(() => {
    if (!Array.isArray(props.value)) return [];

    const enumOptions = props.options.enumOptions;

    if (enumOptions && Array.isArray(enumOptions) && enumOptions.length > 0) {
      return (
        enumOptions
          ?.filter(
            option => props.value.indexOf(option.value) !== -1 && option.label
          )
          ?.map(option => option.label) ?? []
      );
    }

    return (props.value as string[]) ?? [];
  }, [enumOptions, props.value]);

  const options = getCheckedItems();

  if (options.length === 0) {
    return null;
  }

  const hasGDPR = props.schema.title === 'GDPR regulation';

  return (
    <KeyValue dataCyName={props.name} title={props.schema.title}>
      {hasGDPR ? <> {options?.[0]} </> : <ProseList items={options} />}
    </KeyValue>
  );
};
